<h2 mat-dialog-title>{{'dialogs.agentLeadOfferRefused.title' | translate}}: {{lead.id}}
  <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<div mat-dialog-content>
  <p>{{'agent.offer.refused' | translate}}</p>
</div>
